import { classNames } from "@ember-decorators/component";
import ComboBoxComponent from "select-kit/components/combo-box";
import FontSelectorRow from "./font-selector/font-selector-row";
import { pluginApiIdentifiers, selectKitOptions } from "./select-kit";
import SelectedFont from "./selected-font";
const FontSelector = dt7948.c(class FontSelector extends ComboBoxComponent {
  modifyComponentForRow() {
    return FontSelectorRow;
  }
}, [selectKitOptions({
  selectedNameComponent: SelectedFont
}), pluginApiIdentifiers(["font-selector"]), classNames("font-selector")]);
export default FontSelector;